import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function NavMenu() {
  const location = useLocation();
  return (
    <ul className="hidden md:flex items-center space-x-6">
      <Link className={`${location.pathname === "/" && "font-semibold"} cursor-pointer`} id="lws-bookStore" to="/">
        <li>Book Store</li>
      </Link>
      <Link to="/AddBook" className={`${location.pathname === "/AddBook" && "font-semibold"} cursor-pointer`} id="lws-addBook">
        <li>Add Book</li>
      </Link>
    </ul>
  );
}
